// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.dashboard-settings {
    max-width: 1200px;
    margin: 0 auto;
    padding: 2rem;
    font-family: Arial, sans-serif;
    color: #333;
}

h1 {
    font-size: 2rem;
    margin-bottom: 0.5rem;
    color: #0F3443;
}

.description {
    color: #666;
    margin-bottom: 2rem;
}

.settings-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 1.5rem;
}

.setting-item {
    background-color: #f8f9fa;
    border-radius: 8px;
    padding: 1.5rem;
    display: flex;
    gap: 1.5rem;
    flex-direction: row;
    transition: all 0.3s ease;
    cursor: pointer;
    text-decoration: none;
    color: inherit;
}

    .setting-item:hover {
        background-color: #e6f7f2;
        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
        transform: translateY(-5px);
    }

.icon-wrapper {
    background-color: #0F3443;
    color: white;
    width: 48px;
    height: 48px;
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 2rem;
}

    .icon-wrapper i {
        font-size: 1.5rem;
    }

.setting-item .content h3 {
    font-size: 1.1rem;
    margin: 0 0 0.5rem 0;
    color: #0F3443;
    display: flex;
    align-items: center;
    justify-content: space-between;
}

    .setting-item .content h3 i {
        font-size: 0.9rem;
        opacity: 0.7;
    }

.setting-description {
    margin-bottom: 0;
    font-size: 0.9rem;
    color: #666;
    line-height: 1.4;
}

@media (max-width: 1024px) {
    .settings-grid {
        grid-template-columns: repeat(2, 1fr);
    }
}

@media (max-width: 768px) {
    .settings-grid {
        grid-template-columns: 1fr;
    }
}
`, "",{"version":3,"sources":["webpack://./src/app/settings/emptypages/empty.base.page.css"],"names":[],"mappings":"AAAA;IACI,iBAAiB;IACjB,cAAc;IACd,aAAa;IACb,8BAA8B;IAC9B,WAAW;AACf;;AAEA;IACI,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,qCAAqC;IACrC,WAAW;AACf;;AAEA;IACI,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,aAAa;IACb,WAAW;IACX,mBAAmB;IACnB,yBAAyB;IACzB,eAAe;IACf,qBAAqB;IACrB,cAAc;AAClB;;IAEI;QACI,yBAAyB;QACzB,yCAAyC;QACzC,2BAA2B;IAC/B;;AAEJ;IACI,yBAAyB;IACzB,YAAY;IACZ,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,aAAa;AACjB;;IAEI;QACI,iBAAiB;IACrB;;AAEJ;IACI,iBAAiB;IACjB,oBAAoB;IACpB,cAAc;IACd,aAAa;IACb,mBAAmB;IACnB,8BAA8B;AAClC;;IAEI;QACI,iBAAiB;QACjB,YAAY;IAChB;;AAEJ;IACI,gBAAgB;IAChB,iBAAiB;IACjB,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI;QACI,qCAAqC;IACzC;AACJ;;AAEA;IACI;QACI,0BAA0B;IAC9B;AACJ","sourcesContent":[".dashboard-settings {\n    max-width: 1200px;\n    margin: 0 auto;\n    padding: 2rem;\n    font-family: Arial, sans-serif;\n    color: #333;\n}\n\nh1 {\n    font-size: 2rem;\n    margin-bottom: 0.5rem;\n    color: #0F3443;\n}\n\n.description {\n    color: #666;\n    margin-bottom: 2rem;\n}\n\n.settings-grid {\n    display: grid;\n    grid-template-columns: repeat(3, 1fr);\n    gap: 1.5rem;\n}\n\n.setting-item {\n    background-color: #f8f9fa;\n    border-radius: 8px;\n    padding: 1.5rem;\n    display: flex;\n    gap: 1.5rem;\n    flex-direction: row;\n    transition: all 0.3s ease;\n    cursor: pointer;\n    text-decoration: none;\n    color: inherit;\n}\n\n    .setting-item:hover {\n        background-color: #e6f7f2;\n        box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);\n        transform: translateY(-5px);\n    }\n\n.icon-wrapper {\n    background-color: #0F3443;\n    color: white;\n    width: 48px;\n    height: 48px;\n    border-radius: 8px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    padding: 2rem;\n}\n\n    .icon-wrapper i {\n        font-size: 1.5rem;\n    }\n\n.setting-item .content h3 {\n    font-size: 1.1rem;\n    margin: 0 0 0.5rem 0;\n    color: #0F3443;\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n}\n\n    .setting-item .content h3 i {\n        font-size: 0.9rem;\n        opacity: 0.7;\n    }\n\n.setting-description {\n    margin-bottom: 0;\n    font-size: 0.9rem;\n    color: #666;\n    line-height: 1.4;\n}\n\n@media (max-width: 1024px) {\n    .settings-grid {\n        grid-template-columns: repeat(2, 1fr);\n    }\n}\n\n@media (max-width: 768px) {\n    .settings-grid {\n        grid-template-columns: 1fr;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
